import React, { useState, useEffect } from "react";
import { Box, Typography, Avatar } from "@mui/material";
import { Star, StarHalf, StarOutline } from "@mui/icons-material";
import { connect } from "react-redux";
import config from "../../../config";
import axios from "axios";

const AboutSeller = ({ user, jwtToken, seller }) => {
  const [userProfile, setUserProfile] = useState(null);
  const [averageRating, setAverageRating] = useState(0);
  const [reviewCount, setReviewCount] = useState(0);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(`${config.SERVER_URL}/api/users/edit`, {
          headers: { Authorization: `Bearer ${jwtToken}` },
        });
        if (res.status === 200) setUserProfile(res.data.data);
      } catch {}
    };
    fetchUser();
  }, [jwtToken]);

  useEffect(() => {
    if (!seller?.id) return;
    const fetchReviews = async () => {
      try {
        const res = await axios.get(`${config.SERVER_URL}/api/v1/reviews?seller_id=${seller.id}`, {
          headers: { Authorization: `Bearer ${jwtToken}` },
        });
        if (res.status === 200) {
          const reviews = res.data.reviews || [];
          setReviewCount(reviews.length);
          if (reviews.length > 0) {
            const avg = reviews.reduce((s, r) => s + r.rating, 0) / reviews.length;
            setAverageRating(avg);
          }
        }
      } catch {}
    };
    fetchReviews();
  }, [seller]);

  const renderStars = (rating) => {
    const full = Math.floor(rating);
    const hasHalf = rating - full >= 0.3;
    return Array.from({ length: 5 }, (_, i) => {
      if (i < full) return <Star key={i} sx={{ color: "#FFC001", fontSize: 17 }} />;
      if (i === full && hasHalf) return <StarHalf key={i} sx={{ color: "#FFC001", fontSize: 17 }} />;
      return <StarOutline key={i} sx={{ color: "#333", fontSize: 17 }} />;
    });
  };

  const planName = seller?.user?.subscriptions?.[0]?.plan?.name;

  return (
    <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "16px", p: 3, textAlign: "center" }}>
      <Avatar
        src={userProfile?.user_profile?.url || user?.avatar_url}
        alt={user?.full_name}
        sx={{ width: 80, height: 80, mx: "auto", mb: 2, border: "3px solid rgba(255,192,1,0.25)", boxShadow: "0 0 20px rgba(255,192,1,0.08)" }}
      />
      <Typography sx={{ fontWeight: 800, fontSize: "17px", color: "#fff", mb: 0.3 }}>
        {user?.full_name}
      </Typography>
      {planName && (
        <Typography sx={{ color: "#FFC001", fontSize: "12px", fontWeight: 600, mb: 1.5 }}>
          {planName} Plan
        </Typography>
      )}
      <Box sx={{ display: "flex", justifyContent: "center", gap: 0.3, mb: 0.5, mt: planName ? 0 : 1 }}>
        {renderStars(averageRating)}
      </Box>
      <Typography sx={{ color: "#555", fontSize: "12px" }}>
        {averageRating > 0 ? averageRating.toFixed(1) : "No ratings yet"}
        {reviewCount > 0 ? ` · ${reviewCount} review${reviewCount !== 1 ? "s" : ""}` : ""}
      </Typography>
    </Box>
  );
};

const mapStateToProps = ({ Auth, Seller }) => ({
  user: Auth.user,
  seller: Seller.seller,
  jwtToken: Auth.jwtToken,
});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AboutSeller);
